// extracted by mini-css-extract-plugin
export var lane = "marquee-module--lane--4f529";
export var marquee = "marquee-module--marquee--1d0f4";